import { render, staticRenderFns } from "./CodeValidation.vue?vue&type=template&id=65b56474"
import script from "./CodeValidation.vue?vue&type=script&lang=ts"
export * from "./CodeValidation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports